import styled from 'styled-components'

export const NursingCalculator = styled.div`
    width: fit-content;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        width: 100%;
    }

    .headline-container {
        .headline {
            font-size: 18px;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.39;
            display: flex;
            flex-direction: column;
            font-weight: bold;
            text-align: start;
            margin-bottom: 9px;
            color: ${ (props) => props.theme.colors['standard-schwarz'] };

            @media (max-width: 879px) {
                font-size: 16px;
                font-weight: bold;
            }
        }

        p {
            max-width: 750px;
        }
    }

    .table-cell-style {
        max-width: 750px;
        background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
        border: solid white;
        border-width: 2px 2px 1px;
        padding: 20px;
        font-weight: lighter;
        vertical-align: baseline;

        @media (max-width: 879px) {
            padding: 0 0 10px;
            background: white;
        }
    }

    .explanation-container {
        max-width: 750px;

        .info-headline {
            margin-top: 21px;
            font-size: 18px;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.39;
            display: flex;
            flex-direction: column;
            font-weight: bold;
            text-align: start;
            margin-bottom: 9px;
            color: ${ (props) => props.theme.colors['standard-schwarz'] };

            @media (max-width: 879px) {
                font-size: 16px;
                font-weight: bold;
            }
        }

        .cost-info {
            > p:first-child > b > l {
                font-size: 18px;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.39;
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                font-weight: bold;
                text-align: start;
                margin-bottom: 9px;
            }
        }
    }
}

.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-content: center;

    label {
        padding: 12px;
        margin: 0;
        display: block;
    }

    .thead-select, .thead-input {
        min-width: 370px;
        border: 1px solid #e4e5e5;
    }

    .thead-select {
        height: fit-content;
    }

    .thead-input {
        padding-left: 10px;
        font-weight: lighter;
    }

    @media (max-width: 879px) {
        flex-direction: column;

        label {
            padding: 0;
            margin-bottom: 9px;
            display: block;
        }

        .thead-select, .thead-input {
            min-width: 100%;
            border: 1px solid #e4e5e5;
        }

        .thead-input {
            height: 50px;
            font-weight: lighter;
        }
    }
}

.flex-row + .flex-row {
    margin-top: 10px;
}

.explanation-container {
    p {
        margin-top: 20px;
    }
}

.flex-row.info-icon-select {
    align-items: baseline;

    @media screen and (max-width: 897px) {
        & {
            flex-direction: row;
        }

        & .thead-select {
            min-width: calc(100% - 26px);
        }
    }

    & > span {
        padding-left: 10px;
    }
}

`
